var _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOval(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 9,
    r: 5,
    transform: "translate(1 -3)",
    fill: "#F1F1F1",
    stroke: "#515864",
    fillRule: "evenodd"
  })));
}
export default SvgOval;